import React, { useState } from "react";
// import { useNotification } from "../../contexts/NotificationContext";
import "./NotificationPermission.css";
import { useNotification } from "src/context/NotificationContext";

const NotificationPermission = () => {
  const {
    permission,
    requestPermission,
    isPermissionGranted,
    isPermissionDenied,
    isPermissionDefault,
  } = useNotification();

  const [isDismissed, setIsDismissed] = useState(false);

  const handleRequestPermission = async () => {
    await requestPermission();
  };

  const handleEnableManually = () => {
    alert(
      "Untuk mengaktifkan notifikasi secara manual:\n\n" +
        "1. Klik ikon 🔒 di samping URL browser\n" +
        '2. Pilih "Site settings" atau "Permissions"\n' +
        '3. Cari "Notifications" dan pilih "Allow"\n' +
        "4. Refresh halaman ini",
    );
  };

  const handleDismiss = () => {
    setIsDismissed(true);
    // Simpan ke localStorage agar tidak muncul lagi
    localStorage.setItem("notification_permission_dismissed", "true");
  };

  // Cek apakah sudah pernah dismiss
  React.useEffect(() => {
    const dismissed = localStorage.getItem("notification_permission_dismissed");
    if (dismissed === "true") {
      setIsDismissed(true);
    }
  }, []);

  if (isDismissed || isPermissionGranted) {
    return null;
  }

  if (isPermissionDenied) {
    return (
      <div className="notification-permission denied">
        <div className="permission-icon">🔕</div>
        <div className="permission-text">
          <strong>Notifikasi Dinonaktifkan</strong>
          <small>
            Izinkan notifikasi untuk update penting tentang ONT baru, gangguan
            jaringan, dan informasi sistem.
          </small>
          <div className="permission-actions">
            <button
              onClick={handleEnableManually}
              className="permission-button"
            >
              Aktifkan Manual
            </button>
            <button onClick={handleDismiss} className="permission-button">
              Nanti Saja
            </button>
          </div>
        </div>
        <button className="permission-close" onClick={handleDismiss}>
          ×
        </button>
      </div>
    );
  }

  if (isPermissionDefault) {
    return (
      <div className="notification-permission default">
        <div className="permission-icon">🔔</div>
        <div className="permission-text">
          <strong>Aktifkan Notifikasi Real-time</strong>
          <small>
            Dapatkan pemberitahuan instan tentang:
            <br />• ONT baru terdeteksi
            {/* <br />• Status jaringan
            
            <br />• Update sistem penting */}
          </small>
          <div className="permission-actions">
            <button
              onClick={handleRequestPermission}
              className="permission-button primary"
            >
              Izinkan Notifikasi
            </button>
            <button onClick={handleDismiss} className="permission-button">
              Nanti Saja
            </button>
          </div>
        </div>
        <button className="permission-close" onClick={handleDismiss}>
          ×
        </button>
      </div>
    );
  }

  return null;
};

export default NotificationPermission;
